<!--首页-->
<template>
  <div class="gray-back" style="height: 100%;padding: 40px 0;">
    <div class="container_wrap">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
<!--          <div class="search"  v-rblink="{name:'ChaSearchAll',query:{}}" >-->
<!--            <img src="../../../assets/images/icon_search.png" alt srcset />-->
<!--            <div class="placeholder">搜索你想找的信息</div>-->
<!--          </div>-->

          <!-- <van-tabs v-model="active" animated class="active-tab" v-show="cate_list.length>1" @change="cateChange" sticky>
            <van-tab v-for="(item,index) in cate_list" :key="index">
              <template #title>
                <span class="active-tab-num" v-if="item.num>0">{{item.num}}</span>
                {{item.name}}
              </template>
            </van-tab>
          </van-tabs> -->

<!--          <div v-for="(row,i) in list" :key="i" v-rblink="{name:'NewsDetail',query:{id:row.id }}" >-->
<!--            &lt;!&ndash; 无图 style==1 &ndash;&gt;-->
<!--            <NewsItem1 :row="row" v-if="row.pics.length==0"></NewsItem1>-->
<!--            &lt;!&ndash; 有图 style==2 &ndash;&gt;-->
<!--            <NewsItem2 :row="row" v-if="row.pics.length==1"></NewsItem2>-->
<!--            &lt;!&ndash; 视频 style==3 &ndash;&gt;-->
<!--            <NewsItem3 v-if="false"></NewsItem3>-->
<!--            &lt;!&ndash; 多图 style==4 &ndash;&gt;-->
<!--            <NewsItem4 :row="row" v-if="row.pics.length>1"></NewsItem4>-->
<!--          </div>-->

          <news-list-item
              v-for="(item, i) in list"
              :key="i"
              :NewsItemData="item"
              @click.native="itemClickFun(item)"
          ></news-list-item>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<style scoped>
/* @import '../../assets/style/index.css'; */
.box >>> .active-tab {
  margin-top: 0;
}

.container_wrap {
  width: 1240px;
  margin: 0 auto;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgb(0 0 0 / 5%);
  border-radius: 20px;
  padding: 16px 45px 0 30px;
  box-sizing: border-box;
}
.placeholder {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(186, 186, 186, 1);
}
.search {
  width: 7rem;
  height: 0.6rem;
  background: rgba(239, 239, 244, 1);
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px auto;
}
.search img {
  width: 0.3rem;
  height: 0.3rem;
  margin-right: 0.2rem;
}
.comments-detail-top {
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-bottom: 5px solid #f3f3f3;
  position: absolute;
  top: -10px;
  left: 10px;
}
.comments-user-desc {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
.comments-user-name {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #586b94;
}

.zan-box {
  display: flex;
  flex-direction: row-reverse;
  padding: 5px 10px;
  border-bottom: 1px solid #e6e6e6;
}

.user-zan-face {
  width: 22px;
  height: 22px;
  border-radius: 22px;
  margin-right: 4px;
}
.zan-num {
  padding: 1px 5px;
  font-size: 11px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
.comments-detail {
  background: #f3f3f3;
  margin-left: 40px;
  border-radius: 5px;
  padding-bottom: 10px;
  position: relative;
}
.activity-desc {
  padding-left: 40px;
}
.activity-detail-bottom {
  padding-left: 40px;
  margin-top: 10px;
}
.activity-place-box {
  display: flex;
  align-items: center;
}
.release-time {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  margin-left: 5px;
  display: flex;
  justify-content: space-between;
}
.release-time img {
  width: 28px;
  height: 26px;
}
.activity-place-box img {
  width: 15px;
  height: 20px;
}
.activity-place {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  margin-left: 5px;
}
.detail-header {
  height: 40px;
  padding: 10px 10px;
  background: #fff;
}
.user-face {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  overflow: hidden;
  float: left;
}
.user-face img {
  height: 32px;
  width: 32px;
}
.user-info {
  margin-left: 5px;
  float: left;
}
.user-info view {
  height: 50px;
  line-height: 50px;
}
.user-names {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.look-info {
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  line-height: 17px;
}
.video-bottom {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  margin-top: 5px;
}
.active-items-title-read {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 58%;
}
.active-item-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}
.news-style2 .news-img-box {
  width: 40%;
}
.news-style2 .news-img-box img {
  width: 100%;
  height: 1.4rem;
}
.news-style3 img {
  margin-top: 10px;
  width: 100%;
}

.acitve-item-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 20px;
}
.active-itme-read {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.acitve-items {
  width: 6.7rem;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
}
.video-items {
  width: 6.7rem;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  margin: 10px auto;
}
.comments-items {
  width: 6.7rem;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  margin: 10px auto;
}
.active-tab {
  margin-top: 0.6rem;
}
.active-tab-num {
  width: 0.34rem;
  height: 0.34rem;
  background: #f05656;
  text-align: center;
  line-height: 0.34rem;
  display: block;
  position: absolute;
  right: -10px;
  top: -10px;
  border-radius: 0.34rem;
  color: #fff;
}
.active-tab >>> .van-tab__text {
  position: relative;
}
.active-tab >>> .van-tabs__nav {
  background: #f8f8f8;
}
.active-tab >>> [class*="van-hairline"]::after {
  border-top: none;
}
.activity-detail-top {
  width: 100%;
  background-size: 100% 4.69rem;
  background: url("../../../assets/images/activity/pic-shuo-top-1@2x.png")
    no-repeat;
  background-size: 100%;
  position: relative;
  overflow: hidden;
}
.top-info {
  width: 6.9rem;
  height: 5.3rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 7px;
  margin: 2.1rem auto;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
}
.info-top-box {
  height: 1.45rem;
  padding: 0.26rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  position: relative;
}
.info-top-box img {
  width: 1.08rem;
  height: 1.08rem;
  position: absolute;
  top: -0.36rem;
}
.activity-detail-title {
  font-size: 19px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  margin: 5px 0;
  text-indent: 1.34rem;
}
.activity-detail-desc {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 18px;
}
.info-main-box {
  height: 2.4rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}
.activity-dynamic {
  height: 33px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 33px;
  text-indent: 0.28rem;
}
.info-dynamic-items {
  display: flex;
  justify-content: space-between;
  flex: 1;
}
.info-dynamic-items .dynamic-item {
  width: 25%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.dynamic-item img {
  width: 0.6rem;
  height: 0.6rem;
  display: block;
  margin-bottom: 0.12rem;
}

.info-bottom-box {
  flex: 1;
  display: flex;
  align-items: center;
}
.info-bottom-box img {
  width: 24px;
  height: 24px;
  display: block;
  margin: 0 0.16rem 0 0.28rem;
}
.start-immediately {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  margin-left: 0.14rem;
}
.box {
  background: #f8f8f8;
  padding-bottom: 50px;
  overflow: hidden;
}
</style>

<script>
import Vue from "vue";
import { Tab, Tabs, List, PullRefresh, Toast } from "vant";
Vue.use(Tab)
  .use(Tabs)
  .use(PullRefresh)
  .use(List)
  .use(Toast);
import NewsItem2 from "@/components/news/NewsItem2.vue";
import NewsItem3 from "@/components/news/NewsItem3.vue";
import NewsItem1 from "@/components/news/NewsItem1.vue";
import NewsItem4 from "@/components/news/NewsItem4.vue";
import NewsListItem from "@/components/mainindex/NewsListItem2";
export default {
  name: "NewsList",
  components: {
    NewsItem2,
    NewsItem3,
    NewsItem1,
    NewsItem4,
    NewsListItem
  },

  data: function() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      active: 0,
      activeTab: [
        { name: "动态", num: 0 },
        { name: "通知公告", num: 9 },
        { name: "视频", num: 0 },
        { name: "图片", num: 9 },
        { name: "更多", num: 0 }
      ],
      list:[],
      cate_list:[],
      params: {
        cate_id: 0,
        sub_cat_id: 0,
        pageNo: 1
      },
    };
  },
  filters: {
    getTimeFormat(valueTime) {
      if (valueTime) {
        // let newData = Date.parse(new Date() + '')
        // let diffTime = Math.abs(newData - valueTime)
        let diffTime = Math.abs(
          new Date().getTime() - new Date(valueTime * 1000).getTime()
        );
        if (diffTime > 7 * 24 * 3600 * 1000) {
          let date = new Date(valueTime);
          // let y = date.getFullYear()
          let m = date.getMonth() + 1;
          m = m < 10 ? "0" + m : m;
          let d = date.getDate();
          d = d < 10 ? "0" + d : d;
          let h = date.getHours();
          h = h < 10 ? "0" + h : h;
          let minute = date.getMinutes();
          let second = date.getSeconds();
          console.log(second);
          minute = minute < 10 ? "1" + minute : minute;
          second = second < 10 ? "0" + second : second;
          return m + "-" + d + " " + h + ":" + minute;
        } else if (
          diffTime < 7 * 24 * 3600 * 1000 &&
          diffTime > 24 * 3600 * 1000
        ) {
          // //注释("一周之内");
          // var time = newData - diffTime;
          let dayNum = Math.floor(diffTime / (24 * 60 * 60 * 1000));
          return dayNum + "天前";
        } else if (diffTime < 24 * 3600 * 1000 && diffTime > 3600 * 1000) {
          // //注释("一天之内");
          // var time = newData - diffTime;
          let dayNum = Math.floor(diffTime / (60 * 60 * 1000));
          return dayNum + "小时前";
        } else if (diffTime < 3600 * 1000 && diffTime > 0) {
          // //注释("一小时之内");
          // var time = newData - diffTime;
          let dayNum = Math.floor(diffTime / (60 * 1000));
          return dayNum + "分钟前";
        }
      }
    }
  },
  mounted() {
    document.title = "新闻中心";


    this.params.cate_id = this.$route.query.cate_id;
    this.params.pageNo = 1;
    this.loading = true;
    this.finished = false;
    this.fetch();
  },
  destroyed() {},
  methods: {
    fetch() {
      let that = this;
      that.$api.get(
              "/api/cms/cmslist",
              that.params,
              res => {
                that.loading = false;
                console.log('fetchok')
                if (res.data.currentpage == 1) {
                  that.isLoading = false;
                  that.list = res.data.list;
                  that.cate_list = [
                    {
                      'id' : 0,
                      'name':'全部'
                    }
                  ];
                  that.cate_list = that.cate_list.concat(res.data.cate_list) ;
                } else {
                  that.list = that.list.concat(res.data.list);
                }

                if (res.data.list.length == 0) {
                  that.finished = true;
                }
                that.params.pageNo += 1;
              },
              res => {
                Toast(res.msg);
              }
      );
    },

    itemClickFun(val) {
      this.$router.push({path: "/cmsdetail", query: {id: val.id}});
    },
    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.fetch();
    },
    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log("this.params.pageNo");
      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.fetch();
        }, 500);
      }
    },
    cateChange(value){
      console.log(value);
      let that = this;
      that.params.sub_cate_id = this.cate_list[value].id;
      that.params.pageNo = 1;
      that.fetch();
    }
  }
};
</script>



// WEBPACK FOOTER //
// NewsList.vue?23a4b2d4